import { useNavigate } from "react-router-dom";
import { VStack } from "../../components/utils";
import { PrimaryCTAButton } from "../quickRound/CTAButtonComponents";

export default function DraftCompanyInfo({
  companyName,
}: {
  companyName?: string;
}) {
  const navigate = useNavigate();
  return (
    <VStack className="min-h-[70vh] w-full items-center justify-center gap-6 px-4 text-center">
      <img
        src="/emptyStarredCompanies.svg"
        alt="No information available"
        className="h-56 w-auto max-w-full object-contain"
      />
      <VStack className="max-w-md items-center gap-2">
        <p className="text-xl font-semibold text-stone-800">
          {companyName
            ? `${companyName} is a draft company`
            : "Draft company"}
        </p>
        <p className="text-sm leading-6 text-stone-500">
          No event information is available for this company at the moment.
        </p>
      </VStack>
      <PrimaryCTAButton
        event-name="View Company Details"
        className="mt-2"
        onClick={() => navigate("/setting/companydetail")}
      >
        View company details
      </PrimaryCTAButton>
    </VStack>
  );
}
